import { useTranslation } from 'next-i18next';
import DownloadApp from '../../../../new-components/ui/DownloadApp';
import { theme } from '../../../../styles/theme';

const FormFooter = () => {
  const { t } = useTranslation('contact');
  return (
    <>
      <div className="headline">
        <h3 className="headline-1">{t('download_application')}</h3>
      </div>
      <DownloadApp
        iconColor={theme.light.colors.primaryBlue}
        iconWidth="auto"
        iconHeight="38px"
        eventLocation="ContactPage"
      />
    </>
  );
};

export default FormFooter;
